import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Subject, timer, Subscription } from 'rxjs';
import { Observable } from 'rxjs';
import { BaseService } from './base.service';

import * as _ from 'lodash';
import { GlobalsService } from '../../shared/services/globals.service';
import { DispatchBoardSearch } from '../models/DispatchBoardSearch';
import { PersonBus } from '../models/PersonBus';
import { BehaviorSubject } from 'rxjs';
import { DispatchDropLocation } from '../models/DispatchDropLocation';
import { DropDownFilterSettings } from '@progress/kendo-angular-dropdowns';
import { DispatchAssignmentBus } from '../models/DispatchAssignmentBus';
import { v_DispatchBus } from '../models/v_DispatchBus';
import { DragParent } from '../enums/DragParent';
import { DateFunctions } from '../static/date-functions';

@Injectable()
export class DispatchBoardService extends BaseService {

    constructor(private globals: GlobalsService, _http: HttpClient, ) {
        super(_http);
        this.baseUrl = this.rootUrl + "DispatchBoard/";
    }

    initiateTimer() {
        this.refreshTimer = timer(1000, 100000);
        this.timerSub = this.refreshTimer.subscribe(t => this.updateTimer(t));
    }
    updateTimer(ticks: number) {
        this.timerTicks.next(ticks % this.refreshInterval);
        if (this.timerTicks.value % this.refreshInterval === 0 && !this.refreshHalt.value) {
            this.refreshTrigger.next(true);
            //alert('refresh!!');
        } else if (this.timerTicks.value % this.refreshInterval === 0) {

        }
    }

    manRefresh() {
        this.timerSub.unsubscribe();
        this.initiateTimer();
        this.refreshTrigger.next(true);
    }

    // Board Globals
    defaultView: string = '';
    techList: any;
    statusList: any;
    ticks: number = 0;
    refreshInterval: number = 90;
    calendarWeek: any = {
        sun: new Date(),
        mon: new Date(),
        tue: new Date(),
        wed: new Date(),
        thu: new Date(),
        fri: new Date(),
        sat: new Date()
    };
    calendarDay: any = {
        day: new Date(),
    };
    public filterSettings: DropDownFilterSettings = {
        caseSensitive: false,
        operator: 'contains'
    };

    //Shared Board Data
    boardViews: any;
    boardStatusesData: any;
    boardPersonsData: any;
    allPeople: PersonBus[];
    allStatuses: any;
    statusToRefresh: any;
    idToRemove: any;
    showfutureDispatchs:boolean = false;
    public searchParams: DispatchBoardSearch;
    public dispatchSort: string;

    techDispatches: v_DispatchBus[] = [];
    techAssignments: DispatchAssignmentBus[];

    dragParent: DragParent = null;
    startDate: Date = DateFunctions.getDateNow();
    // Timers
    refreshTimer: Observable<number>;
    timerSub: Subscription;

    // Observable string sources
    private dispatchDraggingStart = new BehaviorSubject<any>(null);
    private dispatchDraggingDrop = new Subject<any>();
    public dragState = new BehaviorSubject<boolean>(false);
    private dropLocation = new Subject<DispatchDropLocation>();
    private mouseHover = new Subject<DispatchDropLocation>();
    private hoverStatusPanel = new BehaviorSubject<boolean>(false);
    private statusDetailPanelClose = new Subject<boolean>();
    private hoverTechPanel = new BehaviorSubject<DispatchDropLocation>(null);
    private assignTech = new Subject<string>();
    private timerTicks = new BehaviorSubject<number>(0);
    private refreshTrigger = new Subject<boolean>();
    private refreshHalt = new BehaviorSubject<boolean>(false);
    private selectedDispatch = new BehaviorSubject<string>('');
    private selectedAssignment = new BehaviorSubject<string>('');
    private dragParentSub = new BehaviorSubject<DragParent>(DragParent.statusPanelDetail);
    private networkFunction = new Subject<boolean>();
    private calendarWeekData = new BehaviorSubject<any>(this.calendarWeek);
    private calendarSingleDay = new BehaviorSubject<any>(this.calendarDay);
    private dispatchesForTech = new Subject<v_DispatchBus[]>();
    private dispatchAssignmentsForTech = new Subject<DispatchAssignmentBus[]>();
    private refreshCalendar = new Subject<boolean>();
    private futureDispatchs = new Subject<boolean>();

    // Observable string streams
    futureDispatchs$ = this.futureDispatchs.asObservable();
    refreshCalendar$ = this.refreshCalendar.asObservable();
    dispatchDragStart$ = this.dispatchDraggingStart.asObservable();
    dispatchDragDrop$ = this.dispatchDraggingDrop.asObservable();
    dragState$ = this.dragState.asObservable();
    dropLocation$ = this.dropLocation.asObservable();
    mouseHover$ = this.mouseHover.asObservable();
    hoverStatusPanel$ = this.hoverStatusPanel.asObservable();
    statusDetailPanelClose$ = this.statusDetailPanelClose.asObservable();
    hoverTechPanel$ = this.hoverTechPanel.asObservable();
    assignTech$ = this.assignTech.asObservable();
    timerTicks$ = this.timerTicks.asObservable();
    refreshTrigger$ = this.refreshTrigger.asObservable();
    refreshHalt$ = this.refreshHalt.asObservable();
    selectedDispatch$ = this.selectedDispatch.asObservable();
    selectedAssignment$ = this.selectedAssignment.asObservable();
    dragParentSub$ = this.dragParentSub.asObservable();
    networkFunction$ = this.networkFunction.asObservable();
    calendarWeekData$ = this.calendarWeekData.asObservable();
    calendarSingleDay$ = this.calendarSingleDay.asObservable();
    dispatchesForTech$ = this.dispatchesForTech.asObservable();
    dispatchAssignmentsForTech$ = this.dispatchAssignmentsForTech.asObservable();

    getStatusToRefresh() {

        return this.statusToRefresh;
    }
    setStatusToRefresh(invalue:any) {

        this.statusToRefresh = invalue;
    }

    getStartDate() {

        return this.startDate;
    }
    setStartDate(invalue: any) {

        this.startDate = invalue;
    }
    getIdToRemove() {

        return this.idToRemove;
    }
    setIdToRemove(invalue: any) {

        this.idToRemove = invalue;
    }
    refreshCalendarData(invalue: boolean) {

        this.refreshCalendar.next(invalue);
       // this.refreshTrigger.next(invalue);
    }
    futureDispatchsData(invalue: boolean) {
        this.showfutureDispatchs=invalue
        this.futureDispatchs.next(invalue);
        // this.refreshTrigger.next(invalue);
    }
    getShowfutureDispatchs() {

        return this.showfutureDispatchs;
    }
    setShowfutureDispatchs(value) {

        this.showfutureDispatchs=value;
    }
    dispatchDragging(dispatch: string, dragState: boolean, dragParent?: DragParent) {
        if (dragParent) {
            this.setDragParent(dragParent);
        }
        if (dragState) {
            this.setRefreshHalt(true);
            this.selectedDispatch.next('');
            this.dispatchDraggingStart.next(dispatch);
        } else {
            this.setRefreshHalt(false);
            this.dispatchDraggingDrop.next(dispatch);
            this.hoverStatusPanel.next(false);
        }
        this.dragState.next(dragState);
    }
    dispatchDropped(location: DispatchDropLocation) {
        this.dropLocation.next(location);
        this.dragState.next(false);
        this.hoverStatusPanel.next(false);
        this.hoverTechPanel.next(null);
    }
    mouseHovering(location: DispatchDropLocation) {
        this.mouseHover.next(location);
    }
    hoveringStatusPanel(hover: boolean) {
        if (this.dragState.getValue()) {
            this.hoverStatusPanel.next(hover);
        }
    }
    hoveringTechPanel(hover: DispatchDropLocation) {
        if (this.dragState.getValue()) {
            hover.popup = true;
            this.hoverTechPanel.next(hover);
        }
    }
    dragStateCheck() {

        return this.dragState.getValue();

    }
    openAssignTech(dispatch: string) {
        this.assignTech.next(dispatch);
    }
    closeStatusDetailPanel() {
        this.statusDetailPanelClose.next(true);
    }
    setRefreshHalt(halt: boolean) {
        this.refreshHalt.next(halt);
    }
    setSelectedDispatch(dispatch: string) {
        this.selectedDispatch.next(dispatch);
    }
    setSelectedAssignment(assignment: string) {
        this.selectedAssignment.next(assignment);
    }
    setDragParent(parent: DragParent) {
        this.dragParent = parent;
        this.dragParentSub.next(parent);
    }
    setNetworkFunction(state: boolean) {
        this.networkFunction.next(state);
    }
    setCalendarWeek(week: any) {
        this.calendarWeekData.next(week);
    }
    setcalendarSingleDay(day: any) {
        this.calendarSingleDay.next(day);
    }
    hasSearchParams() {
        if (this.searchParams.divisions && this.searchParams.divisions.length > 0) return true;
        if (this.searchParams.states && this.searchParams.states.length > 0) return true;
        if (this.searchParams.acctMgrs && this.searchParams.acctMgrs.length > 0) return true;
        if (this.searchParams.acctClasses && this.searchParams.acctClasses.length > 0) return true;
        if (this.searchParams.onCallRegions && this.searchParams.onCallRegions.length > 0) return true;
        if (this.searchParams.customers && this.searchParams.customers.length > 0) return true;
        if (this.searchParams.srvConst ) return true;

            return false;
    }
    GetOpenDispatches(search: DispatchBoardSearch): Observable<any> {
        //var s_search = JSON.stringify(search);
        var s_search = JSON.stringify((this.searchParams));
        let options = this.getOptionsU('', "dispatchboardsearch", s_search);
        let url_call: string = this.baseUrl + "GetOpenDispatches";
        return this._http.get(url_call, options);
    }

    //! REMOVE FEATURE FLAG INPUT WHEN REMOVING ui-dispatch-board-pm-sub-category-sorting flag
    getDispatchesByFilter(search: DispatchBoardSearch, featureFlagValue?: boolean): Observable<any> {
        //var s_search = JSON.stringify(search);
        this.searchParams.userId = this.globals.userId;
        this.searchParams.statusId = search.statusId;
        this.searchParams.customSearch = true;
        this.searchParams.excludeContracts = search.excludeContracts;
        var s_search = JSON.stringify((this.searchParams));
        let options = this.getOptionsU('', "dispatchboardsearch", s_search);
        let url_call: string = this.baseUrl + "GetDispatchesByFilter";
        if (featureFlagValue){  //! REMOVE WHEN CLEANING UP ui-dispatch-board-pm-sub-category-sorting flag
            url_call= this.baseUrl + "GetDispatchesByFilterV2";
        }
        return this._http.get(url_call, options);
    }
    updateDispatchFilter(search: DispatchBoardSearch): Observable<any> {
        //var s_search = JSON.stringify(search);
        this.searchParams.userId = this.globals.userId;
        this.searchParams.statusId = search.statusId;
        this.searchParams.customSearch = true;
        this.searchParams.excludeContracts = search.excludeContracts;
        var s_search = JSON.stringify((search));
        let options = this.getOptionsU('', "dispatchboardsearch", s_search);
        let url_call: string = this.baseUrl + "UpdateDispatchFilter";
        return this._http.get(url_call, options);
    }

    getTechAssignments(Id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetTechAssignments/" + Id;
        return this.get(url_call);
    }
    getDispatchFilter(): Observable<any> {
        let url_call: string = this.baseUrl + "GetDispatchFilter" ;
        return this.get(url_call);
    }

    getDispatchsByBoardView(Id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetDispatchsByBoardView/" + Id;
        return this.get(url_call);
    }
    GetDispatchesByIdsFilter(search: DispatchBoardSearch,clearSearch:boolean = false): Observable<any> {
        //var s_search = JSON.stringify(search);
        var parm = _.cloneDeep(this.searchParams);

        if (clearSearch) {
            parm.states = [];
            parm.srvConst = null;
            parm.acctClasses = [];
            parm.acctMgrs = [];
       }

        var s_search = JSON.stringify((parm));
        let options = this.getOptionsU('', "dispatchboardsearch", s_search);
        let url_call: string = this.baseUrl + "GetDispatchesByIdsFilter";
        return this._http.get(url_call, options);
    }
    getDefaultBoardView(): Observable<any> {
        let url_call: string = this.baseUrl + "GetDefaultBoardView";
        return this.get(url_call);
    }
    getDefaultBoardFilter(): Observable<any> {
        let url_call: string = this.baseUrl + "GetDefaultBoardFilter";
        return this.get(url_call);
    }
    GetDispatchBoardViews(): Observable<any> {
        let url_call: string = this.baseUrl + "GetDispatchBoardViews";
        return this.get(url_call);
    }
    print(id: any): Observable<any> {
        let dateNow = DateFunctions.getDateNow();
        dateNow.setHours(1,0,0,0);  // deals with timezones mis calclulating the month or day if to late ine the day
        if (this.startDate) {
            dateNow = this.startDate;
            dateNow.setDate(dateNow.getDate() - 1)
        }
        let month: number = dateNow.getMonth() + 1;
        let date: string = dateNow.getFullYear() + "-" + month + "-" + dateNow.getDate(); // + " " + dateNow.getHours() + ":00" + '"';
        let url_call: string = this.baseUrlCPConn + "PrintDispatchSchedule/" + id + "/" + date;
        console.log("disp-brd-svc->print: ", url_call);
        return super.get(url_call);
    }
    SaveDispatchBoardView(saveObj: DispatchBoardSearch): Observable<any> {
        let body = saveObj;
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "SaveDispatchBoardView";
        return this._http.put(url_call, body, { headers });
    }
    GetDispatchBoardViewStatuses(board: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetDispatchBoardViewStatuses/" + board;
        return this.get(url_call);
    }
    GetDispatchBoardViewPersons(board: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetDispatchBoardViewPersons/" + board;
        return this.get(url_call);
    }
    GetDispatchBoardViewFilters(board: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetDispatchBoardViewFilters/" + board;
        return this.get(url_call);
    }
    GetDispatchBoardViewPersonsWCount(board: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetDispatchBoardViewPersonsWCount/" + board;
        return this.get(url_call);
    }
    GetDispatchBoardViewPersonsWCalCount(search: DispatchBoardSearch, board: string): Observable<any> {
        //var s_search = JSON.stringify(search);
        var s_search = JSON.stringify((this.searchParams));
        let options = this.getOptionsU('', "dispatchboardsearch", s_search);
        let url_call: string = this.baseUrl + "GetDispatchBoardViewPersonsWCalCount/" + board;
        return this._http.get(url_call, options);
    }
    GetMostVisitsByLocation(search: DispatchBoardSearch, location: string): Observable<any> {
        //var s_search = JSON.stringify(search);
        var s_search = JSON.stringify((this.searchParams));
        let options = this.getOptionsU('', "dispatchboardsearch", s_search);
        let url_call: string = this.baseUrl + "GetMostVisitsByLocation/" + location;
        return this._http.get(url_call, options);
    }
    SaveDispatchStatus(dispatchId: string, statusId: string): Observable<any> {
        let body = {
            "dispatchId": dispatchId,
            "statusId": statusId
        }
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "ChangeDispatchStatus";
        return this._http.put(url_call, body, { headers });
    }
    GetAllPeople(): Observable<any> {
        let url_call: string = this.baseUrl + "GetAllPeople";
        return this.get(url_call);
    }
    GetAllStatuses(): Observable<any> {
        let url_call: string = this.baseUrl + "GetAllStatuses";
        return this.get(url_call);
    }
    setDispatchesForTech(dispatches: v_DispatchBus[]) {
        this.techDispatches = [];
        this.techDispatches = dispatches;
        this.dispatchesForTech.next(dispatches);
    }
    setDispatcAssignmentsForTech(assignments: DispatchAssignmentBus[]) {
        this.techAssignments = [];
        this.techAssignments = assignments;
        this.dispatchAssignmentsForTech.next(assignments);
    }
    ////////      AZUGA Methods
    GetFleetGroups(search: DispatchBoardSearch, latLong: any): Observable<any> {
        //var s_search = JSON.stringify(search);
        var s_search = JSON.stringify((this.searchParams));
        var headers = new HttpHeaders().set('Content-Type', 'application/json')
            .set('Authorization', 'Basic ' + "YzcyMGVmYzktMjQzMS00OTY2LTlhMTUtMTI0N2RlNGIyODhl")
        let options = {
            headers: headers
        };
        let url_call: string = "https://api.azuga.com/azuga-ws/v1/groups/view.json";
        return this._http.get(url_call, options);
    }
    GetNearestTechs(search: DispatchBoardSearch, latLong: any): Observable<any> {
        //var s_search = JSON.stringify(search);
        var s_search = JSON.stringify((this.searchParams));
        var headers = new HttpHeaders().set('Content-Type', 'application/json')
            .set('Authorization', 'Basic ' + "YzcyMGVmYzktMjQzMS00OTY2LTlhMTUtMTI0N2RlNGIyODhl")
        let options = {
            headers: headers
        };
        let body = {
            "latitude": latLong.lat,
            "longitude": latLong.long,
            "radius": 20,
            "withInTime": 240
        }
        let url_call: string = "https://api.azuga.com/azuga-ws/v2/fleet/nearestvehicles.json"
        return this._http.post(url_call, body, options);
    }
}
